module.exports = __webpack_public_path__ + "static/media/carefulcoding2.f8b1a228.csv";